import { Group, Tooltip, UnstyledButton } from '@mantine/core';
import { IconX } from '@tabler/icons-react';

import { PROJECT_LABELS_LIST, ProjectLabel } from 'src/Utils/projectLabelColors';

import styles from './LabelPicker.module.scss';

interface Props {
  value?: ProjectLabel | null;
  onChange: (value: ProjectLabel | null) => void;
  label?: string;
}

const LabelPicker = ({ value, onChange, label }: Props) => {
  const handleClick = (labelValue: ProjectLabel) => {
    if (value === labelValue) {
      onChange(null);
    } else {
      onChange(labelValue);
    }
  };

  return (
    <div className={styles.container}>
      {label && <div className={styles.label}>{label}</div>}
      <Group gap={8}>
        {PROJECT_LABELS_LIST.map(item => (
          <Tooltip key={item.value} label={item.name} withArrow>
            <UnstyledButton
              className={styles.colorButton}
              style={{ backgroundColor: item.color }}
              onClick={() => handleClick(item.value)}
              data-selected={value === item.value}
            >
              {value === item.value && <IconX size={12} color="white" strokeWidth={3} />}
            </UnstyledButton>
          </Tooltip>
        ))}
        {value && (
          <Tooltip label="Supprimer l'étiquette" withArrow>
            <UnstyledButton className={styles.clearButton} onClick={() => onChange(null)}>
              <IconX size={14} />
            </UnstyledButton>
          </Tooltip>
        )}
      </Group>
    </div>
  );
};

export default LabelPicker;
